import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class TagService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_tags(): any {
    this.logger.info('TAG | get_tags')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.TAG}`, httpOptions).pipe(
      map((res: any) => {
        return res.results
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('TAG | get_tags | catchError | errorMessage: ' + errorMessage)
        return of(errorMessage)
      }),
    )
  }

  get_tags_page(page: number, pageSize: number): any {
    this.logger.info('TAG | get_tags_page | page: ' + page + ' | pageSize: ' + pageSize)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.TAG}?page=${page}&pageSize=${pageSize}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('TAG | get_tags_page | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }

  get_searched_tags(target: string): any {
    this.logger.info('TAG/Search | get_searched_tags | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.TAG}search/?label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'TAG/Search | get_searched_tags | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_pub_searched_tags(target: string): any {
    this.logger.info('TAG/Search All | get_pub_searched_tags | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.TAG}search/?all=true&label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'TAG/Search All | get_pub_searched_tags | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  add_tag(tag: any): any {
    this.logger.info('TAG | add_tag | tag: ' + tag)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: tag,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.TAG}`, userData, httpOptions).pipe(
      map((res: any) => {
        return { success: true, res: res }
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('TAG | add_tag | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  add_tags(tagList: string[]): any {
    this.logger.info('TAG | add_tags | tagList: ' + tagList)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: tagList,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.TAG}`, userData, httpOptions).pipe(
      map((res: any) => {
        return { success: true, res: res }
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('TAG | add_tags | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  edit_tag(tag_data: any): any {
    this.logger.info('TAG | edit_tag | tag_data: ' + tag_data)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: tag_data.label,
    }

    return this.http
      .patch(`${Backend.HOST_CONTAINER + Backend.TAG + tag_data.id + '/'}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('TAG | edit_tag | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  delete_tag(tag_id: number): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .delete(`${Backend.HOST_CONTAINER + Backend.TAG + tag_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('TAG | delete_tag | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
